import { render, staticRenderFns } from "./MadaCardIcon.vue?vue&type=template&id=491f48e4&"
import script from "./MadaCardIcon.vue?vue&type=script&lang=ts&"
export * from "./MadaCardIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports